<script>
export default {
  name: 'AccordionBody',
  props: {
    scale: {
      type: Number,
      default: 1
    },
    content: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: 'black'
    }
  },
  data: () => ({
    visible: false
  }),
  computed: {
    styles () {
      return {
        content: {
          '--max-height': this.visible ? `${this.$refs.content.scrollHeight || 0}px` : '0px',
          '--opacity': this.visible ? 1 : 0,
          '--margin': this.visible ? '15px' : '0px',
          '--color': this.color,
          '--scale': this.scale
        }
      }
    }
  },
  methods: {
    animate () {
      this.visible = !this.visible
    }
  }
}
</script>

<template>
  <div
    ref="content"
    :style="styles.content"
    class="accordion-body-container"
    v-html="content"
  />
</template>

<style lang="scss" scoped>
.accordion-body-container {
  max-height: var(--max-height);
  opacity: var(--opacity);
  margin-bottom: calc(var(--margin) * var(--scale));
  transition: margin 150ms ease-in-out 150ms, opacity 150ms ease-in-out 150ms, max-height 300ms ease-in-out;
  overflow: hidden;
  font: normal calc(16px * var(--scale))/calc(22px * var(--scale)) 'Open Sans';
  color: var(--color);
  padding: 0 calc(90px * var(--scale));
  text-align: justify;
}
</style>
